import React, { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import { ASSETS } from "../lib/constants";

/**
 * Rider character that rides left -> right as the user scrolls down the page.
 * Sticky position keeps it visible during the hero + adjacent sections.
 */
export default function RiderScroll() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll();

  // Map scroll progress (0..1) to an x position from -5vw to 90vw
  const xRaw = useTransform(scrollYProgress, [0, 1], ["-5vw", "92vw"]);
  const x = useSpring(xRaw, { stiffness: 60, damping: 18, mass: 0.6 });

  // Slight bounce while moving
  const yRaw = useTransform(scrollYProgress, [0, 0.5, 1], [0, -8, 0]);
  const y = useSpring(yRaw, { stiffness: 80, damping: 14 });

  return (
    <div
      ref={ref}
      data-testid="rider-scroll"
      aria-hidden="true"
      className="pointer-events-none fixed bottom-4 left-0 z-30 h-40 w-full sm:h-44 md:bottom-6 md:h-48 lg:h-56"
    >
      <motion.img
        src={ASSETS.rider}
        alt=""
        style={{ x, y }}
        animate={{ rotate: [-2, 2, -2] }}
        transition={{ duration: 0.4, repeat: Infinity, ease: "easeInOut" }}
        className="h-full w-auto object-contain drop-shadow-[0_12px_24px_rgba(0,0,0,0.25)]"
      />
    </div>
  );
}
